/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as R2faSetupRouteImport } from './routes/2fa-setup'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WorkspacesRouteImport } from './routes/workspaces'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/_dashboard'
import { Route as LoginVerify2faRouteImport } from './routes/login_.verify-2fa'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/_dashboard/index'
import { Route as AuthenticatedDashboardSettingsRouteImport } from './routes/_authenticated/_dashboard/settings'
import { Route as AuthenticatedDashboardClientsIndexRouteImport } from './routes/_authenticated/_dashboard/clients/index'
import { Route as AuthenticatedDashboardExpensesIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/index'
import { Route as AuthenticatedDashboardInvoicesIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/index'
import { Route as AuthenticatedDashboardLineItemsIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/index'
import { Route as AuthenticatedDashboardQuotesIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/index'
import { Route as AuthenticatedDashboardRecurringInvoicesIndexRouteImport } from './routes/_authenticated/_dashboard/recurring-invoices/index'
import { Route as AuthenticatedDashboardReportsIndexRouteImport } from './routes/_authenticated/_dashboard/reports/index'
import { Route as AuthenticatedDashboardSettingsIndexRouteImport } from './routes/_authenticated/_dashboard/settings/index'
import { Route as AuthenticatedDashboardClientsIdIndexRouteImport } from './routes/_authenticated/_dashboard/clients/$id/index'
import { Route as AuthenticatedDashboardClientsImportIndexRouteImport } from './routes/_authenticated/_dashboard/clients/import/index'
import { Route as AuthenticatedDashboardClientsNewIndexRouteImport } from './routes/_authenticated/_dashboard/clients/new/index'
import { Route as AuthenticatedDashboardExpensesIdIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/$id/index'
import { Route as AuthenticatedDashboardExpensesImportIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/import/index'
import { Route as AuthenticatedDashboardExpensesNewIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/new/index'
import { Route as AuthenticatedDashboardInvoicesIdIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/$id/index'
import { Route as AuthenticatedDashboardInvoicesImportIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/import/index'
import { Route as AuthenticatedDashboardInvoicesNewIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/new/index'
import { Route as AuthenticatedDashboardLineItemsIdIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/$id/index'
import { Route as AuthenticatedDashboardLineItemsImportIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/import/index'
import { Route as AuthenticatedDashboardLineItemsNewIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/new/index'
import { Route as AuthenticatedDashboardQuotesIdIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/$id/index'
import { Route as AuthenticatedDashboardQuotesImportIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/import/index'
import { Route as AuthenticatedDashboardQuotesNewIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/new/index'
import { Route as AuthenticatedDashboardRecurringInvoicesIdIndexRouteImport } from './routes/_authenticated/_dashboard/recurring-invoices/$id/index'
import { Route as AuthenticatedDashboardRecurringInvoicesNewIndexRouteImport } from './routes/_authenticated/_dashboard/recurring-invoices/new/index'
import { Route as AuthenticatedDashboardSettingsDevModeIndexRouteImport } from './routes/_authenticated/_dashboard/settings/dev-mode/index'
import { Route as AuthenticatedDashboardSettingsOrganizationIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/index'
import { Route as AuthenticatedDashboardSettingsPrivacyIndexRouteImport } from './routes/_authenticated/_dashboard/settings/privacy/index'
import { Route as AuthenticatedDashboardSettingsProfileIndexRouteImport } from './routes/_authenticated/_dashboard/settings/profile/index'
import { Route as AuthenticatedDashboardSettingsSecurityIndexRouteImport } from './routes/_authenticated/_dashboard/settings/security/index'
import { Route as AuthenticatedDashboardSettingsTagsIndexRouteImport } from './routes/_authenticated/_dashboard/settings/tags/index'
import { Route as AuthenticatedDashboardSettingsTermsOfServiceIndexRouteImport } from './routes/_authenticated/_dashboard/settings/terms-of-service/index'
import { Route as AuthenticatedDashboardSettingsTermsTemplatesIndexRouteImport } from './routes/_authenticated/_dashboard/settings/terms-templates/index'
import { Route as AuthenticatedDashboardSettingsThemeIndexRouteImport } from './routes/_authenticated/_dashboard/settings/theme/index'
import { Route as AuthenticatedDashboardSettingsUsersIndexRouteImport } from './routes/_authenticated/_dashboard/settings/users/index'
import { Route as AuthenticatedDashboardClientsIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/clients/$id/edit/index'
import { Route as AuthenticatedDashboardClientsImportIdIndexRouteImport } from './routes/_authenticated/_dashboard/clients/import/$id/index'
import { Route as AuthenticatedDashboardExpensesIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/$id/edit/index'
import { Route as AuthenticatedDashboardExpensesImportIdIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/import/$id/index'
import { Route as AuthenticatedDashboardExpensesRecurringIdIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/recurring/$id/index'
import { Route as AuthenticatedDashboardInvoicesIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/$id/edit/index'
import { Route as AuthenticatedDashboardInvoicesImportIdIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/import/$id/index'
import { Route as AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/recurring-invoices/$id/index'
import { Route as AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/recurring-invoices/new/index'
import { Route as AuthenticatedDashboardLineItemsIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/$id/edit/index'
import { Route as AuthenticatedDashboardLineItemsImportIdIndexRouteImport } from './routes/_authenticated/_dashboard/line-items/import/$id/index'
import { Route as AuthenticatedDashboardQuotesIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/$id/edit/index'
import { Route as AuthenticatedDashboardQuotesImportIdIndexRouteImport } from './routes/_authenticated/_dashboard/quotes/import/$id/index'
import { Route as AuthenticatedDashboardRecurringInvoicesIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/recurring-invoices/$id/edit/index'
import { Route as AuthenticatedDashboardSettingsOrganizationAccessIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/access/index'
import { Route as AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/accounting-export/index'
import { Route as AuthenticatedDashboardSettingsOrganizationBrandingIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/branding/index'
import { Route as AuthenticatedDashboardSettingsOrganizationInvoicingIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/invoicing/index'
import { Route as AuthenticatedDashboardSettingsOrganizationNotificationsIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/notifications/index'
import { Route as AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/payment-options/index'
import { Route as AuthenticatedDashboardSettingsOrganizationRemindersIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/reminders/index'
import { Route as AuthenticatedDashboardSettingsOrganizationTaxIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/tax/index'
import { Route as AuthenticatedDashboardExpensesRecurringIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/recurring/$id/edit/index'
import { Route as AuthenticatedDashboardExpensesRecurringIdRunsIndexRouteImport } from './routes/_authenticated/_dashboard/expenses/recurring/$id/runs/index'
import { Route as AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRouteImport } from './routes/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/index'
import { Route as AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRouteImport } from './routes/_authenticated/_dashboard/settings/payments/stripe/return/index'
import { Route as AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRouteImport } from './routes/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/index'

const R2faSetupRoute = R2faSetupRouteImport.update({
  id: '/2fa-setup',
  path: '/2fa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkspacesRoute = WorkspacesRouteImport.update({
  id: '/workspaces',
  path: '/workspaces',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const LoginVerify2faRoute = LoginVerify2faRouteImport.update({
  id: '/login_/verify-2fa',
  path: '/login/verify-2fa',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsRoute =
  AuthenticatedDashboardSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardClientsIndexRoute =
  AuthenticatedDashboardClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesIndexRoute =
  AuthenticatedDashboardExpensesIndexRouteImport.update({
    id: '/expenses/',
    path: '/expenses/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesIndexRoute =
  AuthenticatedDashboardInvoicesIndexRouteImport.update({
    id: '/invoices/',
    path: '/invoices/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsIndexRoute =
  AuthenticatedDashboardLineItemsIndexRouteImport.update({
    id: '/line-items/',
    path: '/line-items/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesIndexRoute =
  AuthenticatedDashboardQuotesIndexRouteImport.update({
    id: '/quotes/',
    path: '/quotes/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardRecurringInvoicesIndexRoute =
  AuthenticatedDashboardRecurringInvoicesIndexRouteImport.update({
    id: '/recurring-invoices/',
    path: '/recurring-invoices/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardReportsIndexRoute =
  AuthenticatedDashboardReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsIndexRoute =
  AuthenticatedDashboardSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardClientsIdIndexRoute =
  AuthenticatedDashboardClientsIdIndexRouteImport.update({
    id: '/clients/$id/',
    path: '/clients/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardClientsImportIndexRoute =
  AuthenticatedDashboardClientsImportIndexRouteImport.update({
    id: '/clients/import/',
    path: '/clients/import/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardClientsNewIndexRoute =
  AuthenticatedDashboardClientsNewIndexRouteImport.update({
    id: '/clients/new/',
    path: '/clients/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesIdIndexRoute =
  AuthenticatedDashboardExpensesIdIndexRouteImport.update({
    id: '/expenses/$id/',
    path: '/expenses/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesImportIndexRoute =
  AuthenticatedDashboardExpensesImportIndexRouteImport.update({
    id: '/expenses/import/',
    path: '/expenses/import/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesNewIndexRoute =
  AuthenticatedDashboardExpensesNewIndexRouteImport.update({
    id: '/expenses/new/',
    path: '/expenses/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesIdIndexRoute =
  AuthenticatedDashboardInvoicesIdIndexRouteImport.update({
    id: '/invoices/$id/',
    path: '/invoices/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesImportIndexRoute =
  AuthenticatedDashboardInvoicesImportIndexRouteImport.update({
    id: '/invoices/import/',
    path: '/invoices/import/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesNewIndexRoute =
  AuthenticatedDashboardInvoicesNewIndexRouteImport.update({
    id: '/invoices/new/',
    path: '/invoices/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsIdIndexRoute =
  AuthenticatedDashboardLineItemsIdIndexRouteImport.update({
    id: '/line-items/$id/',
    path: '/line-items/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsImportIndexRoute =
  AuthenticatedDashboardLineItemsImportIndexRouteImport.update({
    id: '/line-items/import/',
    path: '/line-items/import/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsNewIndexRoute =
  AuthenticatedDashboardLineItemsNewIndexRouteImport.update({
    id: '/line-items/new/',
    path: '/line-items/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesIdIndexRoute =
  AuthenticatedDashboardQuotesIdIndexRouteImport.update({
    id: '/quotes/$id/',
    path: '/quotes/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesImportIndexRoute =
  AuthenticatedDashboardQuotesImportIndexRouteImport.update({
    id: '/quotes/import/',
    path: '/quotes/import/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesNewIndexRoute =
  AuthenticatedDashboardQuotesNewIndexRouteImport.update({
    id: '/quotes/new/',
    path: '/quotes/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardRecurringInvoicesIdIndexRoute =
  AuthenticatedDashboardRecurringInvoicesIdIndexRouteImport.update({
    id: '/recurring-invoices/$id/',
    path: '/recurring-invoices/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardRecurringInvoicesNewIndexRoute =
  AuthenticatedDashboardRecurringInvoicesNewIndexRouteImport.update({
    id: '/recurring-invoices/new/',
    path: '/recurring-invoices/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsDevModeIndexRoute =
  AuthenticatedDashboardSettingsDevModeIndexRouteImport.update({
    id: '/dev-mode/',
    path: '/dev-mode/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationIndexRoute =
  AuthenticatedDashboardSettingsOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsPrivacyIndexRoute =
  AuthenticatedDashboardSettingsPrivacyIndexRouteImport.update({
    id: '/privacy/',
    path: '/privacy/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsProfileIndexRoute =
  AuthenticatedDashboardSettingsProfileIndexRouteImport.update({
    id: '/profile/',
    path: '/profile/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsSecurityIndexRoute =
  AuthenticatedDashboardSettingsSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsTagsIndexRoute =
  AuthenticatedDashboardSettingsTagsIndexRouteImport.update({
    id: '/tags/',
    path: '/tags/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsTermsOfServiceIndexRoute =
  AuthenticatedDashboardSettingsTermsOfServiceIndexRouteImport.update({
    id: '/terms-of-service/',
    path: '/terms-of-service/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsTermsTemplatesIndexRoute =
  AuthenticatedDashboardSettingsTermsTemplatesIndexRouteImport.update({
    id: '/terms-templates/',
    path: '/terms-templates/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsThemeIndexRoute =
  AuthenticatedDashboardSettingsThemeIndexRouteImport.update({
    id: '/theme/',
    path: '/theme/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsUsersIndexRoute =
  AuthenticatedDashboardSettingsUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardClientsIdEditIndexRoute =
  AuthenticatedDashboardClientsIdEditIndexRouteImport.update({
    id: '/clients/$id/edit/',
    path: '/clients/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardClientsImportIdIndexRoute =
  AuthenticatedDashboardClientsImportIdIndexRouteImport.update({
    id: '/clients/import/$id/',
    path: '/clients/import/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesIdEditIndexRoute =
  AuthenticatedDashboardExpensesIdEditIndexRouteImport.update({
    id: '/expenses/$id/edit/',
    path: '/expenses/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesImportIdIndexRoute =
  AuthenticatedDashboardExpensesImportIdIndexRouteImport.update({
    id: '/expenses/import/$id/',
    path: '/expenses/import/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesRecurringIdIndexRoute =
  AuthenticatedDashboardExpensesRecurringIdIndexRouteImport.update({
    id: '/expenses/recurring/$id/',
    path: '/expenses/recurring/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesIdEditIndexRoute =
  AuthenticatedDashboardInvoicesIdEditIndexRouteImport.update({
    id: '/invoices/$id/edit/',
    path: '/invoices/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesImportIdIndexRoute =
  AuthenticatedDashboardInvoicesImportIdIndexRouteImport.update({
    id: '/invoices/import/$id/',
    path: '/invoices/import/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute =
  AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRouteImport.update({
    id: '/invoices/recurring-invoices/$id/',
    path: '/invoices/recurring-invoices/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute =
  AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRouteImport.update({
    id: '/invoices/recurring-invoices/new/',
    path: '/invoices/recurring-invoices/new/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsIdEditIndexRoute =
  AuthenticatedDashboardLineItemsIdEditIndexRouteImport.update({
    id: '/line-items/$id/edit/',
    path: '/line-items/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardLineItemsImportIdIndexRoute =
  AuthenticatedDashboardLineItemsImportIdIndexRouteImport.update({
    id: '/line-items/import/$id/',
    path: '/line-items/import/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesIdEditIndexRoute =
  AuthenticatedDashboardQuotesIdEditIndexRouteImport.update({
    id: '/quotes/$id/edit/',
    path: '/quotes/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardQuotesImportIdIndexRoute =
  AuthenticatedDashboardQuotesImportIdIndexRouteImport.update({
    id: '/quotes/import/$id/',
    path: '/quotes/import/$id/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute =
  AuthenticatedDashboardRecurringInvoicesIdEditIndexRouteImport.update({
    id: '/recurring-invoices/$id/edit/',
    path: '/recurring-invoices/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationAccessIndexRoute =
  AuthenticatedDashboardSettingsOrganizationAccessIndexRouteImport.update({
    id: '/organization/access/',
    path: '/organization/access/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute =
  AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRouteImport.update(
    {
      id: '/organization/accounting-export/',
      path: '/organization/accounting-export/',
      getParentRoute: () => AuthenticatedDashboardSettingsRoute,
    } as any,
  )
const AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute =
  AuthenticatedDashboardSettingsOrganizationBrandingIndexRouteImport.update({
    id: '/organization/branding/',
    path: '/organization/branding/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute =
  AuthenticatedDashboardSettingsOrganizationInvoicingIndexRouteImport.update({
    id: '/organization/invoicing/',
    path: '/organization/invoicing/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute =
  AuthenticatedDashboardSettingsOrganizationNotificationsIndexRouteImport.update(
    {
      id: '/organization/notifications/',
      path: '/organization/notifications/',
      getParentRoute: () => AuthenticatedDashboardSettingsRoute,
    } as any,
  )
const AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute =
  AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRouteImport.update(
    {
      id: '/organization/payment-options/',
      path: '/organization/payment-options/',
      getParentRoute: () => AuthenticatedDashboardSettingsRoute,
    } as any,
  )
const AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute =
  AuthenticatedDashboardSettingsOrganizationRemindersIndexRouteImport.update({
    id: '/organization/reminders/',
    path: '/organization/reminders/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationTaxIndexRoute =
  AuthenticatedDashboardSettingsOrganizationTaxIndexRouteImport.update({
    id: '/organization/tax/',
    path: '/organization/tax/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardExpensesRecurringIdEditIndexRoute =
  AuthenticatedDashboardExpensesRecurringIdEditIndexRouteImport.update({
    id: '/expenses/recurring/$id/edit/',
    path: '/expenses/recurring/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute =
  AuthenticatedDashboardExpensesRecurringIdRunsIndexRouteImport.update({
    id: '/expenses/recurring/$id/runs/',
    path: '/expenses/recurring/$id/runs/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute =
  AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRouteImport.update({
    id: '/invoices/recurring-invoices/$id/edit/',
    path: '/invoices/recurring-invoices/$id/edit/',
    getParentRoute: () => AuthenticatedDashboardRoute,
  } as any)
const AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute =
  AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRouteImport.update({
    id: '/payments/stripe/return/',
    path: '/payments/stripe/return/',
    getParentRoute: () => AuthenticatedDashboardSettingsRoute,
  } as any)
const AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute =
  AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRouteImport.update(
    {
      id: '/organization/payment-options/stripe/return/',
      path: '/organization/payment-options/stripe/return/',
      getParentRoute: () => AuthenticatedDashboardSettingsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/2fa-setup': typeof R2faSetupRoute
  '/': typeof AuthenticatedDashboardIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workspaces': typeof WorkspacesRoute
  '/login/verify-2fa': typeof LoginVerify2faRoute
  '/settings': typeof AuthenticatedDashboardSettingsRouteWithChildren
  '/clients/': typeof AuthenticatedDashboardClientsIndexRoute
  '/expenses/': typeof AuthenticatedDashboardExpensesIndexRoute
  '/invoices/': typeof AuthenticatedDashboardInvoicesIndexRoute
  '/line-items/': typeof AuthenticatedDashboardLineItemsIndexRoute
  '/quotes/': typeof AuthenticatedDashboardQuotesIndexRoute
  '/recurring-invoices/': typeof AuthenticatedDashboardRecurringInvoicesIndexRoute
  '/reports/': typeof AuthenticatedDashboardReportsIndexRoute
  '/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/clients/$id/': typeof AuthenticatedDashboardClientsIdIndexRoute
  '/clients/import/': typeof AuthenticatedDashboardClientsImportIndexRoute
  '/clients/new/': typeof AuthenticatedDashboardClientsNewIndexRoute
  '/expenses/$id/': typeof AuthenticatedDashboardExpensesIdIndexRoute
  '/expenses/import/': typeof AuthenticatedDashboardExpensesImportIndexRoute
  '/expenses/new/': typeof AuthenticatedDashboardExpensesNewIndexRoute
  '/invoices/$id/': typeof AuthenticatedDashboardInvoicesIdIndexRoute
  '/invoices/import/': typeof AuthenticatedDashboardInvoicesImportIndexRoute
  '/invoices/new/': typeof AuthenticatedDashboardInvoicesNewIndexRoute
  '/line-items/$id/': typeof AuthenticatedDashboardLineItemsIdIndexRoute
  '/line-items/import/': typeof AuthenticatedDashboardLineItemsImportIndexRoute
  '/line-items/new/': typeof AuthenticatedDashboardLineItemsNewIndexRoute
  '/quotes/$id/': typeof AuthenticatedDashboardQuotesIdIndexRoute
  '/quotes/import/': typeof AuthenticatedDashboardQuotesImportIndexRoute
  '/quotes/new/': typeof AuthenticatedDashboardQuotesNewIndexRoute
  '/recurring-invoices/$id/': typeof AuthenticatedDashboardRecurringInvoicesIdIndexRoute
  '/recurring-invoices/new/': typeof AuthenticatedDashboardRecurringInvoicesNewIndexRoute
  '/settings/dev-mode/': typeof AuthenticatedDashboardSettingsDevModeIndexRoute
  '/settings/organization/': typeof AuthenticatedDashboardSettingsOrganizationIndexRoute
  '/settings/privacy/': typeof AuthenticatedDashboardSettingsPrivacyIndexRoute
  '/settings/profile/': typeof AuthenticatedDashboardSettingsProfileIndexRoute
  '/settings/security/': typeof AuthenticatedDashboardSettingsSecurityIndexRoute
  '/settings/tags/': typeof AuthenticatedDashboardSettingsTagsIndexRoute
  '/settings/terms-of-service/': typeof AuthenticatedDashboardSettingsTermsOfServiceIndexRoute
  '/settings/terms-templates/': typeof AuthenticatedDashboardSettingsTermsTemplatesIndexRoute
  '/settings/theme/': typeof AuthenticatedDashboardSettingsThemeIndexRoute
  '/settings/users/': typeof AuthenticatedDashboardSettingsUsersIndexRoute
  '/clients/$id/edit/': typeof AuthenticatedDashboardClientsIdEditIndexRoute
  '/clients/import/$id/': typeof AuthenticatedDashboardClientsImportIdIndexRoute
  '/expenses/$id/edit/': typeof AuthenticatedDashboardExpensesIdEditIndexRoute
  '/expenses/import/$id/': typeof AuthenticatedDashboardExpensesImportIdIndexRoute
  '/expenses/recurring/$id/': typeof AuthenticatedDashboardExpensesRecurringIdIndexRoute
  '/invoices/$id/edit/': typeof AuthenticatedDashboardInvoicesIdEditIndexRoute
  '/invoices/import/$id/': typeof AuthenticatedDashboardInvoicesImportIdIndexRoute
  '/invoices/recurring-invoices/$id/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute
  '/invoices/recurring-invoices/new/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute
  '/line-items/$id/edit/': typeof AuthenticatedDashboardLineItemsIdEditIndexRoute
  '/line-items/import/$id/': typeof AuthenticatedDashboardLineItemsImportIdIndexRoute
  '/quotes/$id/edit/': typeof AuthenticatedDashboardQuotesIdEditIndexRoute
  '/quotes/import/$id/': typeof AuthenticatedDashboardQuotesImportIdIndexRoute
  '/recurring-invoices/$id/edit/': typeof AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute
  '/settings/organization/access/': typeof AuthenticatedDashboardSettingsOrganizationAccessIndexRoute
  '/settings/organization/accounting-export/': typeof AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute
  '/settings/organization/branding/': typeof AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute
  '/settings/organization/invoicing/': typeof AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute
  '/settings/organization/notifications/': typeof AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute
  '/settings/organization/payment-options/': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute
  '/settings/organization/reminders/': typeof AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute
  '/settings/organization/tax/': typeof AuthenticatedDashboardSettingsOrganizationTaxIndexRoute
  '/expenses/recurring/$id/edit/': typeof AuthenticatedDashboardExpensesRecurringIdEditIndexRoute
  '/expenses/recurring/$id/runs/': typeof AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute
  '/invoices/recurring-invoices/$id/edit/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute
  '/settings/payments/stripe/return/': typeof AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute
  '/settings/organization/payment-options/stripe/return/': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute
}
export interface FileRoutesByTo {
  '/2fa-setup': typeof R2faSetupRoute
  '/': typeof AuthenticatedDashboardIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workspaces': typeof WorkspacesRoute
  '/login/verify-2fa': typeof LoginVerify2faRoute
  '/clients': typeof AuthenticatedDashboardClientsIndexRoute
  '/expenses': typeof AuthenticatedDashboardExpensesIndexRoute
  '/invoices': typeof AuthenticatedDashboardInvoicesIndexRoute
  '/line-items': typeof AuthenticatedDashboardLineItemsIndexRoute
  '/quotes': typeof AuthenticatedDashboardQuotesIndexRoute
  '/recurring-invoices': typeof AuthenticatedDashboardRecurringInvoicesIndexRoute
  '/reports': typeof AuthenticatedDashboardReportsIndexRoute
  '/settings': typeof AuthenticatedDashboardSettingsIndexRoute
  '/clients/$id': typeof AuthenticatedDashboardClientsIdIndexRoute
  '/clients/import': typeof AuthenticatedDashboardClientsImportIndexRoute
  '/clients/new': typeof AuthenticatedDashboardClientsNewIndexRoute
  '/expenses/$id': typeof AuthenticatedDashboardExpensesIdIndexRoute
  '/expenses/import': typeof AuthenticatedDashboardExpensesImportIndexRoute
  '/expenses/new': typeof AuthenticatedDashboardExpensesNewIndexRoute
  '/invoices/$id': typeof AuthenticatedDashboardInvoicesIdIndexRoute
  '/invoices/import': typeof AuthenticatedDashboardInvoicesImportIndexRoute
  '/invoices/new': typeof AuthenticatedDashboardInvoicesNewIndexRoute
  '/line-items/$id': typeof AuthenticatedDashboardLineItemsIdIndexRoute
  '/line-items/import': typeof AuthenticatedDashboardLineItemsImportIndexRoute
  '/line-items/new': typeof AuthenticatedDashboardLineItemsNewIndexRoute
  '/quotes/$id': typeof AuthenticatedDashboardQuotesIdIndexRoute
  '/quotes/import': typeof AuthenticatedDashboardQuotesImportIndexRoute
  '/quotes/new': typeof AuthenticatedDashboardQuotesNewIndexRoute
  '/recurring-invoices/$id': typeof AuthenticatedDashboardRecurringInvoicesIdIndexRoute
  '/recurring-invoices/new': typeof AuthenticatedDashboardRecurringInvoicesNewIndexRoute
  '/settings/dev-mode': typeof AuthenticatedDashboardSettingsDevModeIndexRoute
  '/settings/organization': typeof AuthenticatedDashboardSettingsOrganizationIndexRoute
  '/settings/privacy': typeof AuthenticatedDashboardSettingsPrivacyIndexRoute
  '/settings/profile': typeof AuthenticatedDashboardSettingsProfileIndexRoute
  '/settings/security': typeof AuthenticatedDashboardSettingsSecurityIndexRoute
  '/settings/tags': typeof AuthenticatedDashboardSettingsTagsIndexRoute
  '/settings/terms-of-service': typeof AuthenticatedDashboardSettingsTermsOfServiceIndexRoute
  '/settings/terms-templates': typeof AuthenticatedDashboardSettingsTermsTemplatesIndexRoute
  '/settings/theme': typeof AuthenticatedDashboardSettingsThemeIndexRoute
  '/settings/users': typeof AuthenticatedDashboardSettingsUsersIndexRoute
  '/clients/$id/edit': typeof AuthenticatedDashboardClientsIdEditIndexRoute
  '/clients/import/$id': typeof AuthenticatedDashboardClientsImportIdIndexRoute
  '/expenses/$id/edit': typeof AuthenticatedDashboardExpensesIdEditIndexRoute
  '/expenses/import/$id': typeof AuthenticatedDashboardExpensesImportIdIndexRoute
  '/expenses/recurring/$id': typeof AuthenticatedDashboardExpensesRecurringIdIndexRoute
  '/invoices/$id/edit': typeof AuthenticatedDashboardInvoicesIdEditIndexRoute
  '/invoices/import/$id': typeof AuthenticatedDashboardInvoicesImportIdIndexRoute
  '/invoices/recurring-invoices/$id': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute
  '/invoices/recurring-invoices/new': typeof AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute
  '/line-items/$id/edit': typeof AuthenticatedDashboardLineItemsIdEditIndexRoute
  '/line-items/import/$id': typeof AuthenticatedDashboardLineItemsImportIdIndexRoute
  '/quotes/$id/edit': typeof AuthenticatedDashboardQuotesIdEditIndexRoute
  '/quotes/import/$id': typeof AuthenticatedDashboardQuotesImportIdIndexRoute
  '/recurring-invoices/$id/edit': typeof AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute
  '/settings/organization/access': typeof AuthenticatedDashboardSettingsOrganizationAccessIndexRoute
  '/settings/organization/accounting-export': typeof AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute
  '/settings/organization/branding': typeof AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute
  '/settings/organization/invoicing': typeof AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute
  '/settings/organization/notifications': typeof AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute
  '/settings/organization/payment-options': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute
  '/settings/organization/reminders': typeof AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute
  '/settings/organization/tax': typeof AuthenticatedDashboardSettingsOrganizationTaxIndexRoute
  '/expenses/recurring/$id/edit': typeof AuthenticatedDashboardExpensesRecurringIdEditIndexRoute
  '/expenses/recurring/$id/runs': typeof AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute
  '/invoices/recurring-invoices/$id/edit': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute
  '/settings/payments/stripe/return': typeof AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute
  '/settings/organization/payment-options/stripe/return': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/2fa-setup': typeof R2faSetupRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/reset-password': typeof ResetPasswordRoute
  '/setup': typeof SetupRoute
  '/verify-email': typeof VerifyEmailRoute
  '/workspaces': typeof WorkspacesRoute
  '/_authenticated/_dashboard': typeof AuthenticatedDashboardRouteWithChildren
  '/login_/verify-2fa': typeof LoginVerify2faRoute
  '/_authenticated/_dashboard/settings': typeof AuthenticatedDashboardSettingsRouteWithChildren
  '/_authenticated/_dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/_authenticated/_dashboard/clients/': typeof AuthenticatedDashboardClientsIndexRoute
  '/_authenticated/_dashboard/expenses/': typeof AuthenticatedDashboardExpensesIndexRoute
  '/_authenticated/_dashboard/invoices/': typeof AuthenticatedDashboardInvoicesIndexRoute
  '/_authenticated/_dashboard/line-items/': typeof AuthenticatedDashboardLineItemsIndexRoute
  '/_authenticated/_dashboard/quotes/': typeof AuthenticatedDashboardQuotesIndexRoute
  '/_authenticated/_dashboard/recurring-invoices/': typeof AuthenticatedDashboardRecurringInvoicesIndexRoute
  '/_authenticated/_dashboard/reports/': typeof AuthenticatedDashboardReportsIndexRoute
  '/_authenticated/_dashboard/settings/': typeof AuthenticatedDashboardSettingsIndexRoute
  '/_authenticated/_dashboard/clients/$id/': typeof AuthenticatedDashboardClientsIdIndexRoute
  '/_authenticated/_dashboard/clients/import/': typeof AuthenticatedDashboardClientsImportIndexRoute
  '/_authenticated/_dashboard/clients/new/': typeof AuthenticatedDashboardClientsNewIndexRoute
  '/_authenticated/_dashboard/expenses/$id/': typeof AuthenticatedDashboardExpensesIdIndexRoute
  '/_authenticated/_dashboard/expenses/import/': typeof AuthenticatedDashboardExpensesImportIndexRoute
  '/_authenticated/_dashboard/expenses/new/': typeof AuthenticatedDashboardExpensesNewIndexRoute
  '/_authenticated/_dashboard/invoices/$id/': typeof AuthenticatedDashboardInvoicesIdIndexRoute
  '/_authenticated/_dashboard/invoices/import/': typeof AuthenticatedDashboardInvoicesImportIndexRoute
  '/_authenticated/_dashboard/invoices/new/': typeof AuthenticatedDashboardInvoicesNewIndexRoute
  '/_authenticated/_dashboard/line-items/$id/': typeof AuthenticatedDashboardLineItemsIdIndexRoute
  '/_authenticated/_dashboard/line-items/import/': typeof AuthenticatedDashboardLineItemsImportIndexRoute
  '/_authenticated/_dashboard/line-items/new/': typeof AuthenticatedDashboardLineItemsNewIndexRoute
  '/_authenticated/_dashboard/quotes/$id/': typeof AuthenticatedDashboardQuotesIdIndexRoute
  '/_authenticated/_dashboard/quotes/import/': typeof AuthenticatedDashboardQuotesImportIndexRoute
  '/_authenticated/_dashboard/quotes/new/': typeof AuthenticatedDashboardQuotesNewIndexRoute
  '/_authenticated/_dashboard/recurring-invoices/$id/': typeof AuthenticatedDashboardRecurringInvoicesIdIndexRoute
  '/_authenticated/_dashboard/recurring-invoices/new/': typeof AuthenticatedDashboardRecurringInvoicesNewIndexRoute
  '/_authenticated/_dashboard/settings/dev-mode/': typeof AuthenticatedDashboardSettingsDevModeIndexRoute
  '/_authenticated/_dashboard/settings/organization/': typeof AuthenticatedDashboardSettingsOrganizationIndexRoute
  '/_authenticated/_dashboard/settings/privacy/': typeof AuthenticatedDashboardSettingsPrivacyIndexRoute
  '/_authenticated/_dashboard/settings/profile/': typeof AuthenticatedDashboardSettingsProfileIndexRoute
  '/_authenticated/_dashboard/settings/security/': typeof AuthenticatedDashboardSettingsSecurityIndexRoute
  '/_authenticated/_dashboard/settings/tags/': typeof AuthenticatedDashboardSettingsTagsIndexRoute
  '/_authenticated/_dashboard/settings/terms-of-service/': typeof AuthenticatedDashboardSettingsTermsOfServiceIndexRoute
  '/_authenticated/_dashboard/settings/terms-templates/': typeof AuthenticatedDashboardSettingsTermsTemplatesIndexRoute
  '/_authenticated/_dashboard/settings/theme/': typeof AuthenticatedDashboardSettingsThemeIndexRoute
  '/_authenticated/_dashboard/settings/users/': typeof AuthenticatedDashboardSettingsUsersIndexRoute
  '/_authenticated/_dashboard/clients/$id/edit/': typeof AuthenticatedDashboardClientsIdEditIndexRoute
  '/_authenticated/_dashboard/clients/import/$id/': typeof AuthenticatedDashboardClientsImportIdIndexRoute
  '/_authenticated/_dashboard/expenses/$id/edit/': typeof AuthenticatedDashboardExpensesIdEditIndexRoute
  '/_authenticated/_dashboard/expenses/import/$id/': typeof AuthenticatedDashboardExpensesImportIdIndexRoute
  '/_authenticated/_dashboard/expenses/recurring/$id/': typeof AuthenticatedDashboardExpensesRecurringIdIndexRoute
  '/_authenticated/_dashboard/invoices/$id/edit/': typeof AuthenticatedDashboardInvoicesIdEditIndexRoute
  '/_authenticated/_dashboard/invoices/import/$id/': typeof AuthenticatedDashboardInvoicesImportIdIndexRoute
  '/_authenticated/_dashboard/invoices/recurring-invoices/$id/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute
  '/_authenticated/_dashboard/invoices/recurring-invoices/new/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute
  '/_authenticated/_dashboard/line-items/$id/edit/': typeof AuthenticatedDashboardLineItemsIdEditIndexRoute
  '/_authenticated/_dashboard/line-items/import/$id/': typeof AuthenticatedDashboardLineItemsImportIdIndexRoute
  '/_authenticated/_dashboard/quotes/$id/edit/': typeof AuthenticatedDashboardQuotesIdEditIndexRoute
  '/_authenticated/_dashboard/quotes/import/$id/': typeof AuthenticatedDashboardQuotesImportIdIndexRoute
  '/_authenticated/_dashboard/recurring-invoices/$id/edit/': typeof AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute
  '/_authenticated/_dashboard/settings/organization/access/': typeof AuthenticatedDashboardSettingsOrganizationAccessIndexRoute
  '/_authenticated/_dashboard/settings/organization/accounting-export/': typeof AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute
  '/_authenticated/_dashboard/settings/organization/branding/': typeof AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute
  '/_authenticated/_dashboard/settings/organization/invoicing/': typeof AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute
  '/_authenticated/_dashboard/settings/organization/notifications/': typeof AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute
  '/_authenticated/_dashboard/settings/organization/payment-options/': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute
  '/_authenticated/_dashboard/settings/organization/reminders/': typeof AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute
  '/_authenticated/_dashboard/settings/organization/tax/': typeof AuthenticatedDashboardSettingsOrganizationTaxIndexRoute
  '/_authenticated/_dashboard/expenses/recurring/$id/edit/': typeof AuthenticatedDashboardExpensesRecurringIdEditIndexRoute
  '/_authenticated/_dashboard/expenses/recurring/$id/runs/': typeof AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute
  '/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/': typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute
  '/_authenticated/_dashboard/settings/payments/stripe/return/': typeof AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute
  '/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/': typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/2fa-setup'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/setup'
    | '/verify-email'
    | '/workspaces'
    | '/login/verify-2fa'
    | '/settings'
    | '/clients/'
    | '/expenses/'
    | '/invoices/'
    | '/line-items/'
    | '/quotes/'
    | '/recurring-invoices/'
    | '/reports/'
    | '/settings/'
    | '/clients/$id/'
    | '/clients/import/'
    | '/clients/new/'
    | '/expenses/$id/'
    | '/expenses/import/'
    | '/expenses/new/'
    | '/invoices/$id/'
    | '/invoices/import/'
    | '/invoices/new/'
    | '/line-items/$id/'
    | '/line-items/import/'
    | '/line-items/new/'
    | '/quotes/$id/'
    | '/quotes/import/'
    | '/quotes/new/'
    | '/recurring-invoices/$id/'
    | '/recurring-invoices/new/'
    | '/settings/dev-mode/'
    | '/settings/organization/'
    | '/settings/privacy/'
    | '/settings/profile/'
    | '/settings/security/'
    | '/settings/tags/'
    | '/settings/terms-of-service/'
    | '/settings/terms-templates/'
    | '/settings/theme/'
    | '/settings/users/'
    | '/clients/$id/edit/'
    | '/clients/import/$id/'
    | '/expenses/$id/edit/'
    | '/expenses/import/$id/'
    | '/expenses/recurring/$id/'
    | '/invoices/$id/edit/'
    | '/invoices/import/$id/'
    | '/invoices/recurring-invoices/$id/'
    | '/invoices/recurring-invoices/new/'
    | '/line-items/$id/edit/'
    | '/line-items/import/$id/'
    | '/quotes/$id/edit/'
    | '/quotes/import/$id/'
    | '/recurring-invoices/$id/edit/'
    | '/settings/organization/access/'
    | '/settings/organization/accounting-export/'
    | '/settings/organization/branding/'
    | '/settings/organization/invoicing/'
    | '/settings/organization/notifications/'
    | '/settings/organization/payment-options/'
    | '/settings/organization/reminders/'
    | '/settings/organization/tax/'
    | '/expenses/recurring/$id/edit/'
    | '/expenses/recurring/$id/runs/'
    | '/invoices/recurring-invoices/$id/edit/'
    | '/settings/payments/stripe/return/'
    | '/settings/organization/payment-options/stripe/return/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/2fa-setup'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/setup'
    | '/verify-email'
    | '/workspaces'
    | '/login/verify-2fa'
    | '/clients'
    | '/expenses'
    | '/invoices'
    | '/line-items'
    | '/quotes'
    | '/recurring-invoices'
    | '/reports'
    | '/settings'
    | '/clients/$id'
    | '/clients/import'
    | '/clients/new'
    | '/expenses/$id'
    | '/expenses/import'
    | '/expenses/new'
    | '/invoices/$id'
    | '/invoices/import'
    | '/invoices/new'
    | '/line-items/$id'
    | '/line-items/import'
    | '/line-items/new'
    | '/quotes/$id'
    | '/quotes/import'
    | '/quotes/new'
    | '/recurring-invoices/$id'
    | '/recurring-invoices/new'
    | '/settings/dev-mode'
    | '/settings/organization'
    | '/settings/privacy'
    | '/settings/profile'
    | '/settings/security'
    | '/settings/tags'
    | '/settings/terms-of-service'
    | '/settings/terms-templates'
    | '/settings/theme'
    | '/settings/users'
    | '/clients/$id/edit'
    | '/clients/import/$id'
    | '/expenses/$id/edit'
    | '/expenses/import/$id'
    | '/expenses/recurring/$id'
    | '/invoices/$id/edit'
    | '/invoices/import/$id'
    | '/invoices/recurring-invoices/$id'
    | '/invoices/recurring-invoices/new'
    | '/line-items/$id/edit'
    | '/line-items/import/$id'
    | '/quotes/$id/edit'
    | '/quotes/import/$id'
    | '/recurring-invoices/$id/edit'
    | '/settings/organization/access'
    | '/settings/organization/accounting-export'
    | '/settings/organization/branding'
    | '/settings/organization/invoicing'
    | '/settings/organization/notifications'
    | '/settings/organization/payment-options'
    | '/settings/organization/reminders'
    | '/settings/organization/tax'
    | '/expenses/recurring/$id/edit'
    | '/expenses/recurring/$id/runs'
    | '/invoices/recurring-invoices/$id/edit'
    | '/settings/payments/stripe/return'
    | '/settings/organization/payment-options/stripe/return'
  id:
    | '__root__'
    | '/2fa-setup'
    | '/_authenticated'
    | '/forgot-password'
    | '/login'
    | '/onboarding'
    | '/reset-password'
    | '/setup'
    | '/verify-email'
    | '/workspaces'
    | '/_authenticated/_dashboard'
    | '/login_/verify-2fa'
    | '/_authenticated/_dashboard/settings'
    | '/_authenticated/_dashboard/'
    | '/_authenticated/_dashboard/clients/'
    | '/_authenticated/_dashboard/expenses/'
    | '/_authenticated/_dashboard/invoices/'
    | '/_authenticated/_dashboard/line-items/'
    | '/_authenticated/_dashboard/quotes/'
    | '/_authenticated/_dashboard/recurring-invoices/'
    | '/_authenticated/_dashboard/reports/'
    | '/_authenticated/_dashboard/settings/'
    | '/_authenticated/_dashboard/clients/$id/'
    | '/_authenticated/_dashboard/clients/import/'
    | '/_authenticated/_dashboard/clients/new/'
    | '/_authenticated/_dashboard/expenses/$id/'
    | '/_authenticated/_dashboard/expenses/import/'
    | '/_authenticated/_dashboard/expenses/new/'
    | '/_authenticated/_dashboard/invoices/$id/'
    | '/_authenticated/_dashboard/invoices/import/'
    | '/_authenticated/_dashboard/invoices/new/'
    | '/_authenticated/_dashboard/line-items/$id/'
    | '/_authenticated/_dashboard/line-items/import/'
    | '/_authenticated/_dashboard/line-items/new/'
    | '/_authenticated/_dashboard/quotes/$id/'
    | '/_authenticated/_dashboard/quotes/import/'
    | '/_authenticated/_dashboard/quotes/new/'
    | '/_authenticated/_dashboard/recurring-invoices/$id/'
    | '/_authenticated/_dashboard/recurring-invoices/new/'
    | '/_authenticated/_dashboard/settings/dev-mode/'
    | '/_authenticated/_dashboard/settings/organization/'
    | '/_authenticated/_dashboard/settings/privacy/'
    | '/_authenticated/_dashboard/settings/profile/'
    | '/_authenticated/_dashboard/settings/security/'
    | '/_authenticated/_dashboard/settings/tags/'
    | '/_authenticated/_dashboard/settings/terms-of-service/'
    | '/_authenticated/_dashboard/settings/terms-templates/'
    | '/_authenticated/_dashboard/settings/theme/'
    | '/_authenticated/_dashboard/settings/users/'
    | '/_authenticated/_dashboard/clients/$id/edit/'
    | '/_authenticated/_dashboard/clients/import/$id/'
    | '/_authenticated/_dashboard/expenses/$id/edit/'
    | '/_authenticated/_dashboard/expenses/import/$id/'
    | '/_authenticated/_dashboard/expenses/recurring/$id/'
    | '/_authenticated/_dashboard/invoices/$id/edit/'
    | '/_authenticated/_dashboard/invoices/import/$id/'
    | '/_authenticated/_dashboard/invoices/recurring-invoices/$id/'
    | '/_authenticated/_dashboard/invoices/recurring-invoices/new/'
    | '/_authenticated/_dashboard/line-items/$id/edit/'
    | '/_authenticated/_dashboard/line-items/import/$id/'
    | '/_authenticated/_dashboard/quotes/$id/edit/'
    | '/_authenticated/_dashboard/quotes/import/$id/'
    | '/_authenticated/_dashboard/recurring-invoices/$id/edit/'
    | '/_authenticated/_dashboard/settings/organization/access/'
    | '/_authenticated/_dashboard/settings/organization/accounting-export/'
    | '/_authenticated/_dashboard/settings/organization/branding/'
    | '/_authenticated/_dashboard/settings/organization/invoicing/'
    | '/_authenticated/_dashboard/settings/organization/notifications/'
    | '/_authenticated/_dashboard/settings/organization/payment-options/'
    | '/_authenticated/_dashboard/settings/organization/reminders/'
    | '/_authenticated/_dashboard/settings/organization/tax/'
    | '/_authenticated/_dashboard/expenses/recurring/$id/edit/'
    | '/_authenticated/_dashboard/expenses/recurring/$id/runs/'
    | '/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/'
    | '/_authenticated/_dashboard/settings/payments/stripe/return/'
    | '/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  R2faSetupRoute: typeof R2faSetupRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SetupRoute: typeof SetupRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WorkspacesRoute: typeof WorkspacesRoute
  LoginVerify2faRoute: typeof LoginVerify2faRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/2fa-setup': {
      id: '/2fa-setup'
      path: '/2fa-setup'
      fullPath: '/2fa-setup'
      preLoaderRoute: typeof R2faSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workspaces': {
      id: '/workspaces'
      path: '/workspaces'
      fullPath: '/workspaces'
      preLoaderRoute: typeof WorkspacesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_dashboard': {
      id: '/_authenticated/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/login_/verify-2fa': {
      id: '/login_/verify-2fa'
      path: '/login/verify-2fa'
      fullPath: '/login/verify-2fa'
      preLoaderRoute: typeof LoginVerify2faRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_dashboard/': {
      id: '/_authenticated/_dashboard/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/settings': {
      id: '/_authenticated/_dashboard/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/clients/': {
      id: '/_authenticated/_dashboard/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/': {
      id: '/_authenticated/_dashboard/expenses/'
      path: '/expenses'
      fullPath: '/expenses/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/': {
      id: '/_authenticated/_dashboard/invoices/'
      path: '/invoices'
      fullPath: '/invoices/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/': {
      id: '/_authenticated/_dashboard/line-items/'
      path: '/line-items'
      fullPath: '/line-items/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/': {
      id: '/_authenticated/_dashboard/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/recurring-invoices/': {
      id: '/_authenticated/_dashboard/recurring-invoices/'
      path: '/recurring-invoices'
      fullPath: '/recurring-invoices/'
      preLoaderRoute: typeof AuthenticatedDashboardRecurringInvoicesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/reports/': {
      id: '/_authenticated/_dashboard/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedDashboardReportsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/settings/': {
      id: '/_authenticated/_dashboard/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/clients/$id/': {
      id: '/_authenticated/_dashboard/clients/$id/'
      path: '/clients/$id'
      fullPath: '/clients/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/clients/import/': {
      id: '/_authenticated/_dashboard/clients/import/'
      path: '/clients/import'
      fullPath: '/clients/import/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsImportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/clients/new/': {
      id: '/_authenticated/_dashboard/clients/new/'
      path: '/clients/new'
      fullPath: '/clients/new/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/$id/': {
      id: '/_authenticated/_dashboard/expenses/$id/'
      path: '/expenses/$id'
      fullPath: '/expenses/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/import/': {
      id: '/_authenticated/_dashboard/expenses/import/'
      path: '/expenses/import'
      fullPath: '/expenses/import/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesImportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/new/': {
      id: '/_authenticated/_dashboard/expenses/new/'
      path: '/expenses/new'
      fullPath: '/expenses/new/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/$id/': {
      id: '/_authenticated/_dashboard/invoices/$id/'
      path: '/invoices/$id'
      fullPath: '/invoices/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/import/': {
      id: '/_authenticated/_dashboard/invoices/import/'
      path: '/invoices/import'
      fullPath: '/invoices/import/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesImportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/new/': {
      id: '/_authenticated/_dashboard/invoices/new/'
      path: '/invoices/new'
      fullPath: '/invoices/new/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/$id/': {
      id: '/_authenticated/_dashboard/line-items/$id/'
      path: '/line-items/$id'
      fullPath: '/line-items/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/import/': {
      id: '/_authenticated/_dashboard/line-items/import/'
      path: '/line-items/import'
      fullPath: '/line-items/import/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsImportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/new/': {
      id: '/_authenticated/_dashboard/line-items/new/'
      path: '/line-items/new'
      fullPath: '/line-items/new/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/$id/': {
      id: '/_authenticated/_dashboard/quotes/$id/'
      path: '/quotes/$id'
      fullPath: '/quotes/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/import/': {
      id: '/_authenticated/_dashboard/quotes/import/'
      path: '/quotes/import'
      fullPath: '/quotes/import/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesImportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/new/': {
      id: '/_authenticated/_dashboard/quotes/new/'
      path: '/quotes/new'
      fullPath: '/quotes/new/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/recurring-invoices/$id/': {
      id: '/_authenticated/_dashboard/recurring-invoices/$id/'
      path: '/recurring-invoices/$id'
      fullPath: '/recurring-invoices/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardRecurringInvoicesIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/recurring-invoices/new/': {
      id: '/_authenticated/_dashboard/recurring-invoices/new/'
      path: '/recurring-invoices/new'
      fullPath: '/recurring-invoices/new/'
      preLoaderRoute: typeof AuthenticatedDashboardRecurringInvoicesNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/settings/dev-mode/': {
      id: '/_authenticated/_dashboard/settings/dev-mode/'
      path: '/dev-mode'
      fullPath: '/settings/dev-mode/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsDevModeIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/': {
      id: '/_authenticated/_dashboard/settings/organization/'
      path: '/organization'
      fullPath: '/settings/organization/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/privacy/': {
      id: '/_authenticated/_dashboard/settings/privacy/'
      path: '/privacy'
      fullPath: '/settings/privacy/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsPrivacyIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/profile/': {
      id: '/_authenticated/_dashboard/settings/profile/'
      path: '/profile'
      fullPath: '/settings/profile/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsProfileIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/security/': {
      id: '/_authenticated/_dashboard/settings/security/'
      path: '/security'
      fullPath: '/settings/security/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsSecurityIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/tags/': {
      id: '/_authenticated/_dashboard/settings/tags/'
      path: '/tags'
      fullPath: '/settings/tags/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsTagsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/terms-of-service/': {
      id: '/_authenticated/_dashboard/settings/terms-of-service/'
      path: '/terms-of-service'
      fullPath: '/settings/terms-of-service/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsTermsOfServiceIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/terms-templates/': {
      id: '/_authenticated/_dashboard/settings/terms-templates/'
      path: '/terms-templates'
      fullPath: '/settings/terms-templates/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsTermsTemplatesIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/theme/': {
      id: '/_authenticated/_dashboard/settings/theme/'
      path: '/theme'
      fullPath: '/settings/theme/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsThemeIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/users/': {
      id: '/_authenticated/_dashboard/settings/users/'
      path: '/users'
      fullPath: '/settings/users/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsUsersIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/clients/$id/edit/': {
      id: '/_authenticated/_dashboard/clients/$id/edit/'
      path: '/clients/$id/edit'
      fullPath: '/clients/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/clients/import/$id/': {
      id: '/_authenticated/_dashboard/clients/import/$id/'
      path: '/clients/import/$id'
      fullPath: '/clients/import/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardClientsImportIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/$id/edit/': {
      id: '/_authenticated/_dashboard/expenses/$id/edit/'
      path: '/expenses/$id/edit'
      fullPath: '/expenses/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/import/$id/': {
      id: '/_authenticated/_dashboard/expenses/import/$id/'
      path: '/expenses/import/$id'
      fullPath: '/expenses/import/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesImportIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/recurring/$id/': {
      id: '/_authenticated/_dashboard/expenses/recurring/$id/'
      path: '/expenses/recurring/$id'
      fullPath: '/expenses/recurring/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesRecurringIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/$id/edit/': {
      id: '/_authenticated/_dashboard/invoices/$id/edit/'
      path: '/invoices/$id/edit'
      fullPath: '/invoices/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/import/$id/': {
      id: '/_authenticated/_dashboard/invoices/import/$id/'
      path: '/invoices/import/$id'
      fullPath: '/invoices/import/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesImportIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/recurring-invoices/$id/': {
      id: '/_authenticated/_dashboard/invoices/recurring-invoices/$id/'
      path: '/invoices/recurring-invoices/$id'
      fullPath: '/invoices/recurring-invoices/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/recurring-invoices/new/': {
      id: '/_authenticated/_dashboard/invoices/recurring-invoices/new/'
      path: '/invoices/recurring-invoices/new'
      fullPath: '/invoices/recurring-invoices/new/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/$id/edit/': {
      id: '/_authenticated/_dashboard/line-items/$id/edit/'
      path: '/line-items/$id/edit'
      fullPath: '/line-items/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/line-items/import/$id/': {
      id: '/_authenticated/_dashboard/line-items/import/$id/'
      path: '/line-items/import/$id'
      fullPath: '/line-items/import/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardLineItemsImportIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/$id/edit/': {
      id: '/_authenticated/_dashboard/quotes/$id/edit/'
      path: '/quotes/$id/edit'
      fullPath: '/quotes/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/quotes/import/$id/': {
      id: '/_authenticated/_dashboard/quotes/import/$id/'
      path: '/quotes/import/$id'
      fullPath: '/quotes/import/$id/'
      preLoaderRoute: typeof AuthenticatedDashboardQuotesImportIdIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/recurring-invoices/$id/edit/': {
      id: '/_authenticated/_dashboard/recurring-invoices/$id/edit/'
      path: '/recurring-invoices/$id/edit'
      fullPath: '/recurring-invoices/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardRecurringInvoicesIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/settings/organization/access/': {
      id: '/_authenticated/_dashboard/settings/organization/access/'
      path: '/organization/access'
      fullPath: '/settings/organization/access/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationAccessIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/accounting-export/': {
      id: '/_authenticated/_dashboard/settings/organization/accounting-export/'
      path: '/organization/accounting-export'
      fullPath: '/settings/organization/accounting-export/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/branding/': {
      id: '/_authenticated/_dashboard/settings/organization/branding/'
      path: '/organization/branding'
      fullPath: '/settings/organization/branding/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationBrandingIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/invoicing/': {
      id: '/_authenticated/_dashboard/settings/organization/invoicing/'
      path: '/organization/invoicing'
      fullPath: '/settings/organization/invoicing/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationInvoicingIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/notifications/': {
      id: '/_authenticated/_dashboard/settings/organization/notifications/'
      path: '/organization/notifications'
      fullPath: '/settings/organization/notifications/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/payment-options/': {
      id: '/_authenticated/_dashboard/settings/organization/payment-options/'
      path: '/organization/payment-options'
      fullPath: '/settings/organization/payment-options/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/reminders/': {
      id: '/_authenticated/_dashboard/settings/organization/reminders/'
      path: '/organization/reminders'
      fullPath: '/settings/organization/reminders/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationRemindersIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/tax/': {
      id: '/_authenticated/_dashboard/settings/organization/tax/'
      path: '/organization/tax'
      fullPath: '/settings/organization/tax/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationTaxIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/expenses/recurring/$id/edit/': {
      id: '/_authenticated/_dashboard/expenses/recurring/$id/edit/'
      path: '/expenses/recurring/$id/edit'
      fullPath: '/expenses/recurring/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesRecurringIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/expenses/recurring/$id/runs/': {
      id: '/_authenticated/_dashboard/expenses/recurring/$id/runs/'
      path: '/expenses/recurring/$id/runs'
      fullPath: '/expenses/recurring/$id/runs/'
      preLoaderRoute: typeof AuthenticatedDashboardExpensesRecurringIdRunsIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/': {
      id: '/_authenticated/_dashboard/invoices/recurring-invoices/$id/edit/'
      path: '/invoices/recurring-invoices/$id/edit'
      fullPath: '/invoices/recurring-invoices/$id/edit/'
      preLoaderRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardRoute
    }
    '/_authenticated/_dashboard/settings/payments/stripe/return/': {
      id: '/_authenticated/_dashboard/settings/payments/stripe/return/'
      path: '/payments/stripe/return'
      fullPath: '/settings/payments/stripe/return/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
    '/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/': {
      id: '/_authenticated/_dashboard/settings/organization/payment-options/stripe/return/'
      path: '/organization/payment-options/stripe/return'
      fullPath: '/settings/organization/payment-options/stripe/return/'
      preLoaderRoute: typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRouteImport
      parentRoute: typeof AuthenticatedDashboardSettingsRoute
    }
  }
}

interface AuthenticatedDashboardSettingsRouteChildren {
  AuthenticatedDashboardSettingsIndexRoute: typeof AuthenticatedDashboardSettingsIndexRoute
  AuthenticatedDashboardSettingsDevModeIndexRoute: typeof AuthenticatedDashboardSettingsDevModeIndexRoute
  AuthenticatedDashboardSettingsOrganizationIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationIndexRoute
  AuthenticatedDashboardSettingsPrivacyIndexRoute: typeof AuthenticatedDashboardSettingsPrivacyIndexRoute
  AuthenticatedDashboardSettingsProfileIndexRoute: typeof AuthenticatedDashboardSettingsProfileIndexRoute
  AuthenticatedDashboardSettingsSecurityIndexRoute: typeof AuthenticatedDashboardSettingsSecurityIndexRoute
  AuthenticatedDashboardSettingsTagsIndexRoute: typeof AuthenticatedDashboardSettingsTagsIndexRoute
  AuthenticatedDashboardSettingsTermsOfServiceIndexRoute: typeof AuthenticatedDashboardSettingsTermsOfServiceIndexRoute
  AuthenticatedDashboardSettingsTermsTemplatesIndexRoute: typeof AuthenticatedDashboardSettingsTermsTemplatesIndexRoute
  AuthenticatedDashboardSettingsThemeIndexRoute: typeof AuthenticatedDashboardSettingsThemeIndexRoute
  AuthenticatedDashboardSettingsUsersIndexRoute: typeof AuthenticatedDashboardSettingsUsersIndexRoute
  AuthenticatedDashboardSettingsOrganizationAccessIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationAccessIndexRoute
  AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute
  AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute
  AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute
  AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute
  AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute
  AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute
  AuthenticatedDashboardSettingsOrganizationTaxIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationTaxIndexRoute
  AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute: typeof AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute
  AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute: typeof AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute
}

const AuthenticatedDashboardSettingsRouteChildren: AuthenticatedDashboardSettingsRouteChildren =
  {
    AuthenticatedDashboardSettingsIndexRoute:
      AuthenticatedDashboardSettingsIndexRoute,
    AuthenticatedDashboardSettingsDevModeIndexRoute:
      AuthenticatedDashboardSettingsDevModeIndexRoute,
    AuthenticatedDashboardSettingsOrganizationIndexRoute:
      AuthenticatedDashboardSettingsOrganizationIndexRoute,
    AuthenticatedDashboardSettingsPrivacyIndexRoute:
      AuthenticatedDashboardSettingsPrivacyIndexRoute,
    AuthenticatedDashboardSettingsProfileIndexRoute:
      AuthenticatedDashboardSettingsProfileIndexRoute,
    AuthenticatedDashboardSettingsSecurityIndexRoute:
      AuthenticatedDashboardSettingsSecurityIndexRoute,
    AuthenticatedDashboardSettingsTagsIndexRoute:
      AuthenticatedDashboardSettingsTagsIndexRoute,
    AuthenticatedDashboardSettingsTermsOfServiceIndexRoute:
      AuthenticatedDashboardSettingsTermsOfServiceIndexRoute,
    AuthenticatedDashboardSettingsTermsTemplatesIndexRoute:
      AuthenticatedDashboardSettingsTermsTemplatesIndexRoute,
    AuthenticatedDashboardSettingsThemeIndexRoute:
      AuthenticatedDashboardSettingsThemeIndexRoute,
    AuthenticatedDashboardSettingsUsersIndexRoute:
      AuthenticatedDashboardSettingsUsersIndexRoute,
    AuthenticatedDashboardSettingsOrganizationAccessIndexRoute:
      AuthenticatedDashboardSettingsOrganizationAccessIndexRoute,
    AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute:
      AuthenticatedDashboardSettingsOrganizationAccountingExportIndexRoute,
    AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute:
      AuthenticatedDashboardSettingsOrganizationBrandingIndexRoute,
    AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute:
      AuthenticatedDashboardSettingsOrganizationInvoicingIndexRoute,
    AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute:
      AuthenticatedDashboardSettingsOrganizationNotificationsIndexRoute,
    AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute:
      AuthenticatedDashboardSettingsOrganizationPaymentOptionsIndexRoute,
    AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute:
      AuthenticatedDashboardSettingsOrganizationRemindersIndexRoute,
    AuthenticatedDashboardSettingsOrganizationTaxIndexRoute:
      AuthenticatedDashboardSettingsOrganizationTaxIndexRoute,
    AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute:
      AuthenticatedDashboardSettingsPaymentsStripeReturnIndexRoute,
    AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute:
      AuthenticatedDashboardSettingsOrganizationPaymentOptionsStripeReturnIndexRoute,
  }

const AuthenticatedDashboardSettingsRouteWithChildren =
  AuthenticatedDashboardSettingsRoute._addFileChildren(
    AuthenticatedDashboardSettingsRouteChildren,
  )

interface AuthenticatedDashboardRouteChildren {
  AuthenticatedDashboardSettingsRoute: typeof AuthenticatedDashboardSettingsRouteWithChildren
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
  AuthenticatedDashboardClientsIndexRoute: typeof AuthenticatedDashboardClientsIndexRoute
  AuthenticatedDashboardExpensesIndexRoute: typeof AuthenticatedDashboardExpensesIndexRoute
  AuthenticatedDashboardInvoicesIndexRoute: typeof AuthenticatedDashboardInvoicesIndexRoute
  AuthenticatedDashboardLineItemsIndexRoute: typeof AuthenticatedDashboardLineItemsIndexRoute
  AuthenticatedDashboardQuotesIndexRoute: typeof AuthenticatedDashboardQuotesIndexRoute
  AuthenticatedDashboardRecurringInvoicesIndexRoute: typeof AuthenticatedDashboardRecurringInvoicesIndexRoute
  AuthenticatedDashboardReportsIndexRoute: typeof AuthenticatedDashboardReportsIndexRoute
  AuthenticatedDashboardClientsIdIndexRoute: typeof AuthenticatedDashboardClientsIdIndexRoute
  AuthenticatedDashboardClientsImportIndexRoute: typeof AuthenticatedDashboardClientsImportIndexRoute
  AuthenticatedDashboardClientsNewIndexRoute: typeof AuthenticatedDashboardClientsNewIndexRoute
  AuthenticatedDashboardExpensesIdIndexRoute: typeof AuthenticatedDashboardExpensesIdIndexRoute
  AuthenticatedDashboardExpensesImportIndexRoute: typeof AuthenticatedDashboardExpensesImportIndexRoute
  AuthenticatedDashboardExpensesNewIndexRoute: typeof AuthenticatedDashboardExpensesNewIndexRoute
  AuthenticatedDashboardInvoicesIdIndexRoute: typeof AuthenticatedDashboardInvoicesIdIndexRoute
  AuthenticatedDashboardInvoicesImportIndexRoute: typeof AuthenticatedDashboardInvoicesImportIndexRoute
  AuthenticatedDashboardInvoicesNewIndexRoute: typeof AuthenticatedDashboardInvoicesNewIndexRoute
  AuthenticatedDashboardLineItemsIdIndexRoute: typeof AuthenticatedDashboardLineItemsIdIndexRoute
  AuthenticatedDashboardLineItemsImportIndexRoute: typeof AuthenticatedDashboardLineItemsImportIndexRoute
  AuthenticatedDashboardLineItemsNewIndexRoute: typeof AuthenticatedDashboardLineItemsNewIndexRoute
  AuthenticatedDashboardQuotesIdIndexRoute: typeof AuthenticatedDashboardQuotesIdIndexRoute
  AuthenticatedDashboardQuotesImportIndexRoute: typeof AuthenticatedDashboardQuotesImportIndexRoute
  AuthenticatedDashboardQuotesNewIndexRoute: typeof AuthenticatedDashboardQuotesNewIndexRoute
  AuthenticatedDashboardRecurringInvoicesIdIndexRoute: typeof AuthenticatedDashboardRecurringInvoicesIdIndexRoute
  AuthenticatedDashboardRecurringInvoicesNewIndexRoute: typeof AuthenticatedDashboardRecurringInvoicesNewIndexRoute
  AuthenticatedDashboardClientsIdEditIndexRoute: typeof AuthenticatedDashboardClientsIdEditIndexRoute
  AuthenticatedDashboardClientsImportIdIndexRoute: typeof AuthenticatedDashboardClientsImportIdIndexRoute
  AuthenticatedDashboardExpensesIdEditIndexRoute: typeof AuthenticatedDashboardExpensesIdEditIndexRoute
  AuthenticatedDashboardExpensesImportIdIndexRoute: typeof AuthenticatedDashboardExpensesImportIdIndexRoute
  AuthenticatedDashboardExpensesRecurringIdIndexRoute: typeof AuthenticatedDashboardExpensesRecurringIdIndexRoute
  AuthenticatedDashboardInvoicesIdEditIndexRoute: typeof AuthenticatedDashboardInvoicesIdEditIndexRoute
  AuthenticatedDashboardInvoicesImportIdIndexRoute: typeof AuthenticatedDashboardInvoicesImportIdIndexRoute
  AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute
  AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute
  AuthenticatedDashboardLineItemsIdEditIndexRoute: typeof AuthenticatedDashboardLineItemsIdEditIndexRoute
  AuthenticatedDashboardLineItemsImportIdIndexRoute: typeof AuthenticatedDashboardLineItemsImportIdIndexRoute
  AuthenticatedDashboardQuotesIdEditIndexRoute: typeof AuthenticatedDashboardQuotesIdEditIndexRoute
  AuthenticatedDashboardQuotesImportIdIndexRoute: typeof AuthenticatedDashboardQuotesImportIdIndexRoute
  AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute: typeof AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute
  AuthenticatedDashboardExpensesRecurringIdEditIndexRoute: typeof AuthenticatedDashboardExpensesRecurringIdEditIndexRoute
  AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute: typeof AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute
  AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute: typeof AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute
}

const AuthenticatedDashboardRouteChildren: AuthenticatedDashboardRouteChildren =
  {
    AuthenticatedDashboardSettingsRoute:
      AuthenticatedDashboardSettingsRouteWithChildren,
    AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
    AuthenticatedDashboardClientsIndexRoute:
      AuthenticatedDashboardClientsIndexRoute,
    AuthenticatedDashboardExpensesIndexRoute:
      AuthenticatedDashboardExpensesIndexRoute,
    AuthenticatedDashboardInvoicesIndexRoute:
      AuthenticatedDashboardInvoicesIndexRoute,
    AuthenticatedDashboardLineItemsIndexRoute:
      AuthenticatedDashboardLineItemsIndexRoute,
    AuthenticatedDashboardQuotesIndexRoute:
      AuthenticatedDashboardQuotesIndexRoute,
    AuthenticatedDashboardRecurringInvoicesIndexRoute:
      AuthenticatedDashboardRecurringInvoicesIndexRoute,
    AuthenticatedDashboardReportsIndexRoute:
      AuthenticatedDashboardReportsIndexRoute,
    AuthenticatedDashboardClientsIdIndexRoute:
      AuthenticatedDashboardClientsIdIndexRoute,
    AuthenticatedDashboardClientsImportIndexRoute:
      AuthenticatedDashboardClientsImportIndexRoute,
    AuthenticatedDashboardClientsNewIndexRoute:
      AuthenticatedDashboardClientsNewIndexRoute,
    AuthenticatedDashboardExpensesIdIndexRoute:
      AuthenticatedDashboardExpensesIdIndexRoute,
    AuthenticatedDashboardExpensesImportIndexRoute:
      AuthenticatedDashboardExpensesImportIndexRoute,
    AuthenticatedDashboardExpensesNewIndexRoute:
      AuthenticatedDashboardExpensesNewIndexRoute,
    AuthenticatedDashboardInvoicesIdIndexRoute:
      AuthenticatedDashboardInvoicesIdIndexRoute,
    AuthenticatedDashboardInvoicesImportIndexRoute:
      AuthenticatedDashboardInvoicesImportIndexRoute,
    AuthenticatedDashboardInvoicesNewIndexRoute:
      AuthenticatedDashboardInvoicesNewIndexRoute,
    AuthenticatedDashboardLineItemsIdIndexRoute:
      AuthenticatedDashboardLineItemsIdIndexRoute,
    AuthenticatedDashboardLineItemsImportIndexRoute:
      AuthenticatedDashboardLineItemsImportIndexRoute,
    AuthenticatedDashboardLineItemsNewIndexRoute:
      AuthenticatedDashboardLineItemsNewIndexRoute,
    AuthenticatedDashboardQuotesIdIndexRoute:
      AuthenticatedDashboardQuotesIdIndexRoute,
    AuthenticatedDashboardQuotesImportIndexRoute:
      AuthenticatedDashboardQuotesImportIndexRoute,
    AuthenticatedDashboardQuotesNewIndexRoute:
      AuthenticatedDashboardQuotesNewIndexRoute,
    AuthenticatedDashboardRecurringInvoicesIdIndexRoute:
      AuthenticatedDashboardRecurringInvoicesIdIndexRoute,
    AuthenticatedDashboardRecurringInvoicesNewIndexRoute:
      AuthenticatedDashboardRecurringInvoicesNewIndexRoute,
    AuthenticatedDashboardClientsIdEditIndexRoute:
      AuthenticatedDashboardClientsIdEditIndexRoute,
    AuthenticatedDashboardClientsImportIdIndexRoute:
      AuthenticatedDashboardClientsImportIdIndexRoute,
    AuthenticatedDashboardExpensesIdEditIndexRoute:
      AuthenticatedDashboardExpensesIdEditIndexRoute,
    AuthenticatedDashboardExpensesImportIdIndexRoute:
      AuthenticatedDashboardExpensesImportIdIndexRoute,
    AuthenticatedDashboardExpensesRecurringIdIndexRoute:
      AuthenticatedDashboardExpensesRecurringIdIndexRoute,
    AuthenticatedDashboardInvoicesIdEditIndexRoute:
      AuthenticatedDashboardInvoicesIdEditIndexRoute,
    AuthenticatedDashboardInvoicesImportIdIndexRoute:
      AuthenticatedDashboardInvoicesImportIdIndexRoute,
    AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute:
      AuthenticatedDashboardInvoicesRecurringInvoicesIdIndexRoute,
    AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute:
      AuthenticatedDashboardInvoicesRecurringInvoicesNewIndexRoute,
    AuthenticatedDashboardLineItemsIdEditIndexRoute:
      AuthenticatedDashboardLineItemsIdEditIndexRoute,
    AuthenticatedDashboardLineItemsImportIdIndexRoute:
      AuthenticatedDashboardLineItemsImportIdIndexRoute,
    AuthenticatedDashboardQuotesIdEditIndexRoute:
      AuthenticatedDashboardQuotesIdEditIndexRoute,
    AuthenticatedDashboardQuotesImportIdIndexRoute:
      AuthenticatedDashboardQuotesImportIdIndexRoute,
    AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute:
      AuthenticatedDashboardRecurringInvoicesIdEditIndexRoute,
    AuthenticatedDashboardExpensesRecurringIdEditIndexRoute:
      AuthenticatedDashboardExpensesRecurringIdEditIndexRoute,
    AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute:
      AuthenticatedDashboardExpensesRecurringIdRunsIndexRoute,
    AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute:
      AuthenticatedDashboardInvoicesRecurringInvoicesIdEditIndexRoute,
  }

const AuthenticatedDashboardRouteWithChildren =
  AuthenticatedDashboardRoute._addFileChildren(
    AuthenticatedDashboardRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  R2faSetupRoute: R2faSetupRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SetupRoute: SetupRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WorkspacesRoute: WorkspacesRoute,
  LoginVerify2faRoute: LoginVerify2faRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
